export enum ReportConfigurationBreakdown {
    // GENERIC
    NONE = 'NONE',
    BROWSER = 'BROWSER',
    PLACEMENT = 'PLACEMENT',
    OPERATING_SYSTEM = 'OPERATING_SYSTEM',
    BROWSER_PLACEMENT = 'BROWSER,PLACEMENT',
    BROWSER_OPERATING_SYSTEM = 'BROWSER,OPERATING_SYSTEM',
    BROWSER_PLACEMENT_OPERATING_SYSTEM = 'BROWSER,PLACEMENT,OPERATING_SYSTEM',
    PLACEMENT_OPERATING_SYSTEM = 'PLACEMENT,OPERATING_SYSTEM',
    CHANNEL = 'CHANNEL',
    SPLIT_TEST = 'SPLIT_TEST',
    VARIANT = 'VARIANT',
    STEP = 'STEP',

    ORGANIZATION = 'ORGANIZATION',
    DOMAIN = 'DOMAIN',
    DOMAIN_CHANNEL = 'DOMAIN,CHANNEL',
    DOMAIN_PLACEMENT = 'DOMAIN,PLACEMENT',
    DOMAIN_CHANNEL_PLACEMENT = 'DOMAIN,CHANNEL,PLACEMENT',

    NOTIFICATION = 'NOTIFICATION',
    NOTIFICATION_GROUP = 'NOTIFICATION_GROUP',

    // TIMEZONE
    TIMEZONE = 'TIMEZONE',

    // BUTTON
    BUTTON = 'BUTTON',

    // ATTRITION
    SUBSCRIBER_AGE = 'SUSCRIBER_AGE',
    IMPRESSIONS = 'IMPRESSIONS',
    CLICKS = 'CLICKS',
    PLACEMENT_CHANNEL = 'PLACEMENT,CHANNEL',
}
